import { isAfter, isBefore } from 'date-fns';
import { toDate } from 'date-fns-tz';

const CMS_TIME_ZONE = 'Europe/Paris';

export const isValidDateRange = (start_date?: string, end_date?: string): boolean => {
    const now = new Date();
    const startDate = start_date ? toDate(start_date, { timeZone: CMS_TIME_ZONE }) : null;
    const endDate = end_date ? toDate(end_date, { timeZone: CMS_TIME_ZONE }) : null;
    return (!startDate || isAfter(now, startDate)) && (!endDate || isBefore(now, endDate));
};

export const isValidParcours = (journey: string, parcours: string[]): boolean => {
    return parcours.includes(journey);
};

export const filterValidItems = (
    journey: string,
    parcours: string[],
    start_date?: string,
    end_date?: string,
): boolean => {
    return isValidParcours(journey, parcours) && isValidDateRange(start_date, end_date);
};
